import { TableCard } from '../../../../components'
import { ImportacaoListHeader } from './components/header/ImportacaoListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ImportacaoListTable } from './table/ImportacaoListTable'

const ImportacaoList = () => (
  <TableCard>
    <ImportacaoListHeader />
    <ImportacaoListTable />
  </TableCard>
)

export const ImportacaoListPage = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <ImportacaoList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
